import { defineAction } from '~/prix'
import { z } from 'zod'
import benefitProgramDeleteAction from './benefitProgramDelete.action.json' with { type: 'json' }
import { benefitProgramObject } from '../benefitProgramObject'

const benefitProgramDeleteDefinition = defineAction({
  ...benefitProgramDeleteAction,

  input: z.object({ id: benefitProgramObject.shape.id }),
  output: z.object({}),
})

export default benefitProgramDeleteDefinition
